import * as React from "react";

function SvgCaptureEfi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 39 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.5L19.125 0 38.25 8.5l-19.125 9.563L0 8.5zm8.5 6.375L4.25 17l14.875 6.375L34 17l-4.25-2.125 2.125-1.063L38.25 17l-19.125 8.5L0 17l6.375-3.188L8.5 14.876zM4.25 25.5l4.25-2.125-2.125-1.063L0 25.5 19.125 34l19.125-8.5-6.375-3.188-2.125 1.063L34 25.5l-14.875 6.375L4.25 25.5zM21.045 4.715c.707-.354.707-.927 0-1.28-.707-.354-1.853-.354-2.56 0-.707.353-.707.926 0 1.28.707.353 1.853.353 2.56 0zm-5.108 10.16L17 8.5h5.313V7.438h9.562l-15.938 7.437z"
        fill="#FFF"
      />
    </svg>
  );
}

export default SvgCaptureEfi;
